import DOMPurify from "dompurify";
function SecondHeading({ data }) {
  return (
    <>
      <section className=" scalable_secure_section brr-none border-0 mb-0 ">
        <div className="container">
          <div
            className="mb-3"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(data?.heading || ""),
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(data?.paragraph || ""),
            }}
          />
        </div>
      </section>
    </>
  );
}
export default SecondHeading;
